// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_30-3";
export var dialog = "_30-0";
export var divClassnameSwatch = "_30-8";
export var flexSwatch = "_30-4";
export var header = "_30-1";
export var styleAttributeSwatch = "_30-7";
export var swatch = "_30-2";
export var textHeaderSwatch = "_30-5";
export var webSwatch = "_30-6";